import { render, staticRenderFns } from "./metafileds.vue?vue&type=template&id=648f2998"
import script from "./metafileds.vue?vue&type=script&lang=js"
export * from "./metafileds.vue?vue&type=script&lang=js"
import style0 from "./metafileds.vue?vue&type=style&index=0&id=648f2998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports